import { inject, Injectable } from '@angular/core'
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { TemplateContentUnit, TemplateForm } from '../models/template.model'
import { GlobalErrorService } from '@services/global-error.service'
import { TemplateService } from './template.service'
import { templateExistsValidator } from '../validators/template-exists.validator'
import { templateConditionExistsValidator } from '../validators/template-condition-exists.validator'

@Injectable({ providedIn: 'root' })
export class TemplateFormService {
  private readonly fb = inject(FormBuilder)
  private readonly globalErrorService = inject(GlobalErrorService)
  private readonly apiService = inject(TemplateService)

  public buildForm(): FormGroup<TemplateForm> {
    return this.fb.group({
      uuid: new FormControl<string | null>(null),
      title: new FormControl<string | null>('', { validators: [Validators.required] }),
      description: new FormControl<string | null>(''),
      tags: new FormControl<string[] | null>([]),
      certificateCategory: new FormControl<string | null>('', { validators: [Validators.required] }),
      coverageType: new FormControl<string | null>('', { validators: [Validators.required] }),
      contentUnits: this.createFormArray([]),
      showDetails: new FormControl<boolean | null>(false)
    }) as FormGroup<TemplateForm>
  }

  public createFormArray(controls: FormControl<TemplateContentUnit | null>[]): FormArray<FormControl<TemplateContentUnit | null>> {
    return this.fb.array(controls)
  }

  public addAsyncValidators(
    form: FormGroup<TemplateForm>,
    initialTitle?: string,
    initialCategory?: string,
    initialCoverage?: string
  ): void {
    form.controls.title.setAsyncValidators([
      templateExistsValidator(this.apiService, this.globalErrorService, initialTitle)
    ])
    form.setAsyncValidators([
      templateConditionExistsValidator(this.apiService, this.globalErrorService, initialCategory, initialCoverage)
    ])

    form.controls.title.updateValueAndValidity({ emitEvent: false })
    form.updateValueAndValidity({ emitEvent: false })
    form.markAllAsTouched()
  }
}
